import { render, staticRenderFns } from "./PolicyInvoice.vue?vue&type=template&id=433c04e9&"
import script from "./PolicyInvoice.vue?vue&type=script&lang=js&"
export * from "./PolicyInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports